/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Perm_Product_Pulse_ReadInputs */



/**
* | output |
* | --- |
* | "See Pulse, the weekly health report" |
*
* @param {Perm_Product_Pulse_ReadInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perm_product_pulse_read = /** @type {((inputs?: Perm_Product_Pulse_ReadInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perm_Product_Pulse_ReadInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Видеть Pulse — еженедельный отчёт о состоянии сервера")
	return /** @type {LocalizedString} */ ("See Pulse, the weekly health report")
});